import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { EmployeeAddEditComponent, EmployeeListComponent, EmployeeRoutingModule } from '@user/components/employee';
import { RoleModule } from '../role';
import { EmployeeViewComponent } from './add-edit-list/employee-view.component';

const routes: Routes = [
  { path: '', component: EmployeeListComponent, canActivate: [AuthGuard], data: { title: 'Employee' } },
  { path: 'add-edit', component: EmployeeAddEditComponent, canActivate: [AuthGuard], data: { title: 'Employee Add Edit' } },
  { path: 'add-edit/:id', component: EmployeeAddEditComponent, canActivate: [AuthGuard], data: { title: 'Employee Add Edit' } },
  { path: 'view', component: EmployeeViewComponent, canActivate: [AuthGuard], data: { title: 'Employee View ' } }
];
@NgModule({
  declarations: [EmployeeAddEditComponent, EmployeeViewComponent, EmployeeListComponent],
  imports: [
    EmployeeRoutingModule,
    LayoutModule,
    MaterialModule,
    SharedModule,
    RoleModule
  ],
})
export class EmployeeModule { }
